module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modalcon"
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('span', {
    staticClass: "closebtn",
    on: {
      "click": _vm.setPopup
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "mbox"
  }, [_c('div', {
    staticClass: "modal-body mb0"
  }, [_c('div', {
    staticClass: "row justify-content-center align-content-center my-3"
  }, [_c('div', [_c('div', {
    staticClass: "text-uppercase"
  }, [_c('h2', {
    staticClass: "app-download-header"
  }, [_c('b', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-center align-content-center"
  }, [_c('a', {
    staticClass: "mr-3",
    on: {
      "click": function($event) {
        _vm.triggerEvent('playStore')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo clickable",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/icons/play-store.png",
      "alt": "Download app on google play store",
      "title": "Download app on google play store"
    }
  })]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.triggerEvent('appStore')
      }
    }
  }, [_c('img', {
    staticClass: "app-store-logo clickable",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/icons/app-store.png",
      "alt": "Download app on apple app store",
      "title": "Download app on apple app store"
    }
  })])])])])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9f67ec2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/commonPopUp.vue
// module id = 1079
// module chunks = 111